<template>
    <div class="homeinterativa">
        <PageTitle icon="fas fa-tractor iconInterativoTitulo" main="Gestão de Frota e Equipamentos"
            sub="Monitore as estatísticas dos equipamentos de sua frota" />
        <div class="stats">
            <Stat title="Industriais" :value="stat.maquinas"
                icon="fas fa-industry" color="#2e2d2c" />
            <Stat title="Telecomunicações" :value="stat.baterias"
                icon="fas fa-network-wired" color="#ffd618" />
            <Stat title="Energia Renovável" :value="stat.usuarios"
                icon="fas fa-solar-panel" color="#008fac" />
        </div>
    </div>
</template>

<script>
import PageTitle from '../PageTitle'
import Stat from './Stat'
import axios from 'axios'
import { baseApiUrl } from '@/global'

export default {
    name: 'FrotaInterativa',
    components: { PageTitle, Stat },
    data: function() {
        return {
            stat: {}
        }
    },
    methods: {
        getStats() {
            axios.get(`${baseApiUrl}/stats`).then(res => this.stat = res.data)
        }
    },
    mounted() {
        this.getStats()
    }
}
</script>

<style>
    .stats {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 20px;
    }
    .homeinterativa{
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>